<template>
    <div class="mainClass">
      <div class="animated-bg"></div> <!-- Animated Background -->
      <div class="biclass bi bi-globe"></div>
  
      <!-- Hero Section -->
      <div class="textClass row justify-content-center">
        <div class="col-12 col-md-6 text-center">
          <h1 class="mb-4 animate__animated animate__fadeIn">Welcome to Our Software Company</h1>
          <p class="lead animate__animated animate__fadeIn animate__delay-1s">
            We provide cutting-edge solutions to streamline your business operations.
          </p>
        </div>
      </div>
  
      <!-- Features Section -->
      <div class="row mt-5 text-center">
        <div class="col-12 col-md-4 mb-4">
          <div class="icon-box animate__animated animate__zoomIn">
            <i class="bi bi-globe2"></i>
            <h3 class="mt-3">Web Development</h3>
            <p>Our application is built with efficiency and usability in mind.</p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-4">
          <div class="icon-box animate__animated animate__zoomIn animate__delay-1s">
            <i class="bi bi-cloud-upload"></i>
            <h3 class="mt-3">Cloud Integration</h3>
            <p>Seamless cloud synchronization to ensure your data is always available.</p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-4">
          <div class="icon-box animate__animated animate__zoomIn animate__delay-2s">
            <i class="bi bi-shield-lock"></i>
            <h3 class="mt-3">Security First</h3>
            <p>We prioritize your data security with the latest encryption standards.</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      goToNextPage() {
        this.$router.push({ name: "nextPage" });
      }
    }
  };
  </script>
  
  <style scoped>
  /* Full-width container */
  .mainClass {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  
  /* Animated Background */
  .animated-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    background: linear-gradient(-45deg, #08004d, #0059b3, #0068cf, #01478d);
    background-size: 300% 300%;
    animation: gradientAnimation 10s infinite alternate ease-in-out;
    z-index: -2;
  }
  
  /* Windows Icon */
  .biclass {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    color: rgba(255, 255, 255, 0.2);
    font-size: 200px;
    position: fixed;
    z-index: -1;
  }
  
  .textClass{
    padding-top: 10%;
  }
  
  /* Keyframe Animation */
  @keyframes gradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  
  /* Hero Section */
  h1 {
    font-size: 2.5rem;
    font-weight: bold;
    color: #ecf0f1;
  }
  
  p {
    color: #bdc3c7;
  }
  
  /* Reduce the size of the icon-box */
  .icon-box {
    border: 2px solid #63a7f0;
    padding: 15px; /* Reduced padding */
    border-radius: 8px;
    transition: transform 0.3s ease;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.1);
    color: #f1ecef;
    max-width: 380px; /* Set a maximum width for each card */
    margin: auto; /* Center the cards */
  }
  .icon-box:hover {
    transform: scale(1.04);
  }
  
  /* Reduce icon size */
  .icon-box i {
    font-size: 2.5rem; /* Reduced icon size */
    color: #00ccff;
  }
  
  /* Reduce heading size inside cards */
  .icon-box h3 {
    font-size: 1.2rem; /* Smaller heading */
  }
  
  /* Reduce paragraph text inside cards */
  .icon-box p {
    font-size: 0.9rem; /* Smaller text */
  }
  
  /* Adjust spacing for smaller screens */
  @media (max-width: 768px) {
    .textClass{
    padding-top: 25%;
  }
    .icon-box {
      max-width: 240px; /* Reduce card size on mobile */
      max-height: 100%;
      padding: 10px; /* Less padding */
    }
  
    .icon-box i {
      font-size: 2rem; /* Smaller icons */
    }
  
    .icon-box h3 {
      font-size: 1rem;
    }
  
    .icon-box p {
      font-size: 0.85rem;
    }
  }
  </style>
  